<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5c3.48,0,5.22,1.74,5.22,1.74v5.38l-5.22-3.26l-5.22,3.26v-5.38C-4.72,784.24-2.98,782.5,0.5,782.5L0.5,782.5z
	 M5.72,791.68v1.86l-5.22-3.26l-5.22,3.26v-1.86l5.22-3.26L5.72,791.68z M5.72,795.59v1.69L0.5,802.5l-5.22-5.22v-1.69l5.22-3.26
	L5.72,795.59z"/>
</svg>

</template>